import { Flex } from 'antd'
import SwiperGallery from '@/components/swiper-gallery'
import imageScene1 from '@/assets/img/solution/disaster-relief/scene-1.jpg'
import imageScene2 from '@/assets/img/solution/disaster-relief/scene-2.jpg'
import imageScene3 from '@/assets/img/solution/disaster-relief/scene-3.jpg'
import Styles from './style.module.scss'

const TITLE = 'Safety & Reliability'
const data = [
  'Advanced liquid cooling for thermal stability',
  'Multi-level fire protection (cabinet + system)',
  'Remote EMS for continuous monitoring',
  'Off-grid independence or grid-connected support',
  'Designed for frequency stability and emergency backup',
]

const images = [imageScene1, imageScene2, imageScene3]

export default function SafeReliable() {
  return (
    <Flex align='center' justify='center' className={Styles.safeReliable}>
      <div className={Styles.contentWrapper}>
        <h2>{TITLE}</h2>
        <ul>
          {data.map(t => (
            <li key={t}>{t}</li>
          ))}
        </ul>
      </div>
      <SwiperGallery images={images} interval={3000} />
    </Flex>
  )
}
